import { gql } from '@apollo/client';

export const DELETE_COHORT = gql`
  mutation DeleteCohort($id: ID!) {
    cohort: deleteCohort(id: $id) {
      id
      name
    }
  }
`;
